// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import * as echarts from 'echarts';

import Print from 'vue-print-nb'
// 全局引用
Vue.use(Print);

import i18n from './i18n'

//生成验证码图片
import SIdentify from './components/identify'
Vue.component('s-identify', SIdentify)

//element ui css
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

//自定义css js
import './assets/css/style.css';
import './assets/css/animate.min.css';
import './assets/css/index.css';

import './assets/js/jquery-1.9.1.min.js';
import './assets/js/mobile.js';
import './assets/js/common.js';

//swiper
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

// 1.全局引用
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer)

import api from'./api/api.js'
import utils from './utils/utils.js';
import VueCookies from 'vue-cookies';

// 全局引入Toast
import './components/Toast/toast.css';
import Toast from './components/Toast/index';

//富文本编辑样式
import 'quill/dist/quill.snow.css'

//自定义element ui主题
import './assets/element/index.css'

//引入国际化语言包
// import i18n from './assets/lang';


import Request from './api/request' // 引入封装的文件 - 请求接口方法
import btnControl from './utils/btnControll'
import Breadcrumb from './utils/breadcrumb'

const { request, baseURL,uploadURL } = Request;
Vue.prototype.$http = request;
Vue.prototype.baseURL = baseURL;
Vue.prototype.uploadURL = uploadURL;
Vue.prototype.$btn = btnControl

Vue.prototype.api = api
Vue.prototype.utils = utils
Vue.prototype.echarts = echarts
Vue.prototype.fullscreenLoading = false;//全局加载
Vue.prototype.$breadcrumb = Breadcrumb;//全局加载
//是否是图片
Vue.prototype.videoList=[
  'mp4','wmv','rmvb','asf','mov','m4v','avi','mkv','dat','mkv'
];
Vue.prototype.imagesList =[
  'png','jpg','jpeg','gif'
];

//	点击展开筛选
Vue.prototype.handleFilter = (target) => {
	$(target).slideToggle();
},

Vue.prototype.isImage = function(file){
  var result  =false;
  this.imagesList.forEach(function(item,i){
      if(file.lastIndexOf('.')> 0){
          var filename = file.substr(file.lastIndexOf('.')+1);
          if(filename == item){
              result = true;
              return false;
          }
      }
  })
  return result;
};

Vue.use(ElementUI);
Vue.use(VueCookies)
Vue.use(Toast);



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})


//语言国际化
//npm i vue-i18n -S


//富文本编辑器
//npm install vue-quill-editor --save
// npm install quill-image-extend-module --save-dev

//环信
//npm install easemob-websdk --save



// WEBPACK FOOTER //
// ./src/main.js